import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, first } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, SpinnerComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnDestroy, OnInit {
  private unsubscribe: Subscription[] = [];
  constructor(private authService: AuthService, private router: Router) {
    if (this.authService.currentUserValue) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit(): void {
    this.authService
      .getUserBySession()
      .pipe(first())
      .subscribe((user) => {
        if (user) {
          this.router.navigate(['/']);
        }
      });

    this.login('AzureAD');
  }

  login(provider: string) {
    const loginSubscr = this.authService
      .loginSSO(provider)
      .pipe(first())
      .subscribe();
    this.unsubscribe.push(loginSubscr);
  }

  ngOnDestroy(): void {
    this.unsubscribe.forEach((obs) => obs.unsubscribe());
  }
}
